import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => localStorage.getItem("crn_lang") || "nl");

    const setLang = useCallback((code) => {
        localStorage.setItem("crn_lang", code);
        setLangState(code);
        document.documentElement.lang = code;
    }, []);

    const t = useCallback((path) => {
        const parts = path.split(".");
        const lookup = (dict) => parts.reduce((acc, p) => (acc ? acc[p] : undefined), dict);
        return lookup(translations[lang]) ?? lookup(translations.en) ?? path;
    }, [lang]);

    return (
        <I18nContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
            {children}
        </I18nContext.Provider>
    );
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used within I18nProvider");
    return ctx;
}
